import { FC, useEffect, useState } from 'react';
import './image-upload.less';
import { SvgIcon, Upload } from '@/components';
import { apiService } from '@/shared/apiService';
import {
  beforeUpload,
  checkImgWAndH,
  uuid,
  getFileExtension,
} from '@/shared/utils/tools';
import classnames from 'classnames';
import { sizeMap } from '../const';

interface ImageUploadProps {
  style?: React.CSSProperties;
  imgStyle?: string;
  className?: string;
  defaultUrl?: string;
  type?: string;
  disabled?: boolean;
  getUrl?: (url: string) => void;
}

const ImageUpload: FC<ImageUploadProps> = ({
  style = {},
  imgStyle = '2*2',
  className = '',
  type = 'light',
  disabled = false,
  getUrl = () => {},
  defaultUrl = '',
}) => {
  const [uploadLoading, setUploadLoading] = useState<boolean>(false);
  const [imgUrl, setImgUrl] = useState<string>(defaultUrl);
  const uploadImage = async (file: File) => {
    if (!beforeUpload(file)) {
      return;
    }
    let width = 440,
      height = 440;
    const size = sizeMap.get(imgStyle);
    if (size) {
      width = size.width;
      height = size.height;
    }
    const cRes = await checkImgWAndH(file, width, height);
    if (!cRes) return;
    try {
      setUploadLoading(true);
      // 重命名，防止上传相同图片名不生效
      const newName = uuid() + getFileExtension(file.name);
      const newFile = new File([file], newName, {
        type: file.type,
      });
      const data = await apiService.imgUpload(newFile);
      if (data) {
        setImgUrl(data + '?f=webp');
      }
    } catch (e) {
      console.log(e);
      // 图片上传失败 取消ui上传状态
    } finally {
      setUploadLoading(false);
    }
  };
  useEffect(() => {
    if (imgUrl !== defaultUrl) {
      setImgUrl(defaultUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultUrl]);
  useEffect(() => {
    getUrl(imgUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl]);
  return (
    <div
      className={classnames('image-upload-wrapper', className, type, {
        disabled: disabled,
        able: !disabled,
        hover: uploadLoading,
        imgUrl: imgUrl,
      })}
      style={style}
    >
      {imgUrl ? (
        <div className="inner img">
          <img className="cdn-img" src={imgUrl} alt="" />
        </div>
      ) : (
        <div className="inner dis">
          {type === 'light' ? (
            <>
              <SvgIcon name={'sun'} color="#ecf5ff" width="23" height="23" />
              <p className="p-1">{window.trans('light-mode')}</p>
              <p className="p-2">{window.trans('picture-tips')}</p>
            </>
          ) : (
            <>
              <SvgIcon name={'moon'} color="#f2f4f8" width="23" height="23" />
              <p className="p-1">{window.trans('dark-mode')}</p>
              <p className="p-2">{window.trans('picture-tips')}</p>
            </>
          )}
        </div>
      )}
      <div className="inner upload-div">
        {!disabled && (
          <div
            className={classnames('upload-center-box pr cursor', {
              'del-box': imgUrl,
            })}
          >
            {uploadLoading ? (
              <div className="loading-status-div flex-center">
                <SvgIcon
                  className="loading-icon "
                  name={type === 'light' ? 'sun' : 'moon'}
                  color="#ecf5ff"
                  width="15"
                  height="15"
                />
                <span>上传中</span>
              </div>
            ) : imgUrl ? (
              <div
                className="custom-upload-btn flex-center"
                onClick={() => {
                  setImgUrl('');
                }}
              >
                <SvgIcon
                  name="delete"
                  style={{
                    fill: '#191919',
                  }}
                  width="18"
                  height="18"
                ></SvgIcon>
                <span className="del-span">删除</span>
              </div>
            ) : (
              <Upload
                className="custom-upload-btn flex-center"
                customRequest={(options: any) => {
                  uploadImage(options?.file);
                }}
              >
                <SvgIcon
                  name="arrow-up-circle"
                  style={{
                    fill: type === 'light' ? '#0476EB' : '#61779A',
                  }}
                  width="18"
                  height="18"
                ></SvgIcon>
                <span> 上传图片 </span>
              </Upload>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
